import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'
import TextField from './TextField'
import Hidden from '../../static/images/icon_hidden.svg'
import HiddenHover from '../../static/images/icon_hidden_hover.svg'
import Shown from '../../static/images/icon_shown.svg'
import ShownHover from '../../static/images/icon_shown_hover.svg'

const HideShowPasswordIcon = styled.div`
  background: url(${props => (!props.showPassword ? Shown : Hidden)}) no-repeat;
  background-size: contain;
  position: absolute;
  right: 9px;
  bottom: 14px;
  height: 14px;
  width: 18px;
  cursor: pointer;

  &:hover {
    background: url(${props =>
        !props.showPassword ? ShownHover : HiddenHover})
      no-repeat;
  }
`

export default class PasswordField extends Component {
  constructor() {
    super()
    this.state = {
      showPassword: false
    }
    this.onShowHidePasswordClick = this.onShowHidePasswordClick.bind(this)
  }

  render() {
    return (
      <div style={{ position: 'relative' }}>
        <ReactTooltip
          className="tooltip"
          id={this.props.tooltipId}
          effect="solid"
          getContent={[
            () =>
              this.state.showPassword
                ? 'Click to hide password.'
                : 'Click to show password.'
          ]}
        />
        <TextField
          {...this.props}
          style={this.props.style}
          type={this.state.showPassword ? 'text' : 'password'}
        />
        {this.state.showPassword ? (
          <HideShowPasswordIcon
            showPassword={this.state.showPassword}
            onClick={this.onShowHidePasswordClick}
            data-for={this.props.tooltipId}
            data-tip="Click to hide password."
          />
        ) : (
          <HideShowPasswordIcon
            showPassword={this.state.showPassword}
            onClick={this.onShowHidePasswordClick}
            data-for={this.props.tooltipId}
            data-tip="Click to show password."
          />
        )}
      </div>
    )
  }

  onShowHidePasswordClick(e) {
    e.preventDefault()
    this.setState(state => ({
      showPassword: !state.showPassword
    }))
  }
}

PasswordField.propTypes = {
  tooltipId: PropTypes.string,
  style: PropTypes.object,
  placeholder: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/typography/PasswordField.js